"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = { version: 'v0.44.1-pre.1696502379' };
